import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import AddIcon from '@material-ui/icons/Add'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'
import restClient from 'Shared/hooks/restClient'

const CreateDashboardButton = ({ className = '', cloneSearchId, searchId }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const openModal = () => {
    setName('')
    setModalOpen(true)
  }

  function createDashboard() {
    setError(false)
    setErrorMessage('')

    return restClient.post(`/api/dashboards`, { name, description })
      .then(({ data }) => {
        window.location = data.redirectUrl
      })
      .catch(() => {
        setError(true)
        setErrorMessage("Something went wrong creating the dashboard")
      })
  }


  return (
    <>
      <button className={`button primary ${className}`} onClick={openModal}>
        <AddIcon /> Create Organiser Dashboard
      </button>
      <BackdropModal
        title="Create a new organiser dashboard"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
      >
        <div className='form narrow'>
          <div className='icon circle large margin-bottom'>
            <SvgIconsConversations />
          </div>

          <p className='intro'>First, name your dashboard. This will help you find it later on so be sure to use a descriptive name.</p>

          <div className='fields margin-top'>
            <div className='field'>
              <label>Dashboard name</label>
              <input type='text'
                placeholder='Name your dashboard'
                value={name}
                onChange={(e) => setName(e.target.value || '')}
              />
            </div>
          </div>

          <ServerWaitButton
            className='button block primary no-margin-left'
            disabled={(name || '').length == 0}
            onClick={createDashboard}
          >Begin</ServerWaitButton>
        </div>

        {error && <div className='warning'>{errorMessage}</div>}
      </BackdropModal>
    </>
  )
}

export default CreateDashboardButton
